export default "__VITE_ASSET__fTBFBs55__"